import {Fragment} from "react";
import {WordPressQuoteRatingPackage} from "./WordPressQuoteRatingPackage";
import {WordPressQuoteRatingBrokerage} from "./WordPressQuoteRatingBrokerage";
import {WordPressQuoteRatingLTL} from "./WordPressQuoteRatingLTL";
import {WordPressQuoteRatingMoving} from "./WordPressQuoteRatingMoving";
import {WordPressQuoteRatingCar} from "./WordPressQuoteRatingCar";
import {WordPressQuoteRatingFTL} from "./WordPressQuoteRatingFTL";

export const WordPressQuoteRating = ({
                                         tab,
                                         movingFrom,
                                         movingTo,
                                         shippingDetails,
                                         AIRate,
                                         APIRate,
                                         carRate,
                                         carRateFromAI,
                                         movingRate,
                                         LTLRate,
                                         LTLRateFromAI,
                                         FTLRate,
                                         FTLRateFromAI,
                                         packageRate,
                                         packageLoading,
                                         packageError,
                                         isAbleGetPackageRate,
                                         brokerageRate,
                                         redirectToApp,
                                         lng,
                                         NoRate,
                                         RegisterLink,
                                         Coupon,
                                         Feedback
                                     }) => {

    return (
        <Fragment>
            {
                tab?.toLowerCase() === 'car' ?
                    <WordPressQuoteRatingCar AIRate={AIRate}
                                             APIRate={APIRate}
                                             carRate={carRate}
                                             carRateFromAI={carRateFromAI}
                                             redirectToApp={redirectToApp}
                                             lng={lng}
                                             NoRate={NoRate}
                                             RegisterLink={RegisterLink}
                                             Coupon={Coupon}
                                             Feedback={Feedback}/> :
                    tab?.toLowerCase() === 'moving' ?
                        <WordPressQuoteRatingMoving AIRate={AIRate}
                                                    APIRate={APIRate}
                                                    movingRate={movingRate}
                                                    packageRate={packageRate}
                                                    packageError={packageError}
                                                    packageLoading={packageLoading}
                                                    isAbleGetPackageRate={isAbleGetPackageRate}
                                                    redirectToApp={redirectToApp}
                                                    movingFrom={movingFrom}
                                                    movingTo={movingTo}
                                                    shippingDetails={shippingDetails}
                                                    lng={lng}
                                                    NoRate={NoRate}
                                                    RegisterLink={RegisterLink}
                                                    Coupon={Coupon}
                                                    Feedback={Feedback}/> :
                        tab?.toLowerCase() === 'ltl' ?
                            <WordPressQuoteRatingLTL AIRate={AIRate}
                                                     APIRate={APIRate}
                                                     LTLRate={LTLRate}
                                                     LTLRateFromAI={LTLRateFromAI}
                                                     redirectToApp={redirectToApp}
                                                     lng={lng}
                                                     NoRate={NoRate}
                                                     RegisterLink={RegisterLink}
                                                     Coupon={Coupon}
                                                     Feedback={Feedback}/> :
                            tab?.toLowerCase() === 'package' ?
                                <WordPressQuoteRatingPackage AIRate={AIRate}
                                                             APIRate={APIRate}
                                                             packageRate={packageRate}
                                                             redirectToApp={redirectToApp}
                                                             lng={lng}
                                                             NoRate={NoRate}
                                                             RegisterLink={RegisterLink}
                                                             Coupon={Coupon}
                                                             Feedback={Feedback}/> :
                                tab?.toLowerCase() === 'brokerage' ?
                                    <WordPressQuoteRatingBrokerage AIRae={AIRate}
                                                                   APIRate={APIRate}
                                                                   brokerageRate={brokerageRate}
                                                                   redirectToApp={redirectToApp}
                                                                   movingFrom={movingFrom}
                                                                   movingTo={movingTo}
                                                                   shippingDetails={shippingDetails}
                                                                   lng={lng}
                                                                   NoRate={NoRate}
                                                                   RegisterLink={RegisterLink}
                                                                   Coupon={Coupon}
                                                                   Feedback={Feedback}/> :
                                    <WordPressQuoteRatingFTL AIRate={AIRate}
                                                             APIRate={APIRate}
                                                             FTLRate={FTLRate}
                                                             FTLRateFromAI={FTLRateFromAI}
                                                             redirectToApp={redirectToApp}
                                                             lng={lng}
                                                             NoRate={NoRate}
                                                             RegisterLink={RegisterLink}
                                                             Coupon={Coupon}
                                                             Feedback={Feedback}/>

            }
        </Fragment>
    )
}